import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import CardInteractive from '@/components/layout/CardInteractive.vue';
var PlatformCardSelectable = /*#__PURE__*/function (_Vue) {
  function PlatformCardSelectable() {
    var _this;
    _classCallCheck(this, PlatformCardSelectable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, PlatformCardSelectable, [].concat(args));
    _defineProperty(_this, "platform", void 0);
    _defineProperty(_this, "selected", void 0);
    _defineProperty(_this, "disabled", void 0);
    return _this;
  }
  _inherits(PlatformCardSelectable, _Vue);
  return _createClass(PlatformCardSelectable);
}(Vue);
__decorate([Prop()], PlatformCardSelectable.prototype, "platform", void 0);
__decorate([Prop()], PlatformCardSelectable.prototype, "selected", void 0);
__decorate([Prop()], PlatformCardSelectable.prototype, "disabled", void 0);
PlatformCardSelectable = __decorate([Options({
  components: {
    CardInteractive: CardInteractive
  }
})], PlatformCardSelectable);
export default PlatformCardSelectable;